import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("savior_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const rupiah = (n) =>
  "Rp " + Number(Math.round(n || 0)).toLocaleString("id-ID");

export async function downloadFile(path, fallbackName) {
  const res = await api.get(path, { responseType: "blob" });
  const disposition = res.headers["content-disposition"] || "";
  let name = fallbackName;
  const m = disposition.match(/filename=([^;]+)/);
  if (m) name = m[1].trim().replace(/["']/g, "");
  const url = window.URL.createObjectURL(new Blob([res.data]));
  const a = document.createElement("a");
  a.href = url;
  a.download = name;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => window.URL.revokeObjectURL(url), 4000);
}

export default api;
